import { DEFAULT_CONFIGS } from '@anm/data/hostingDefaults';

var getBlockedVideoData = function getBlockedVideoData(manifest) {
  return {
    audio: {
      path: ''
    },
    uploadId: '',
    projectId: '',
    bestQualityVideo: '',
    sizes: {
      width: manifest.meta.width,
      height: manifest.meta.height
    },
    meta: {
      name: '',
      duration: 1,
      uploadDate: '',
      description: ''
    },
    configs: DEFAULT_CONFIGS,
    customConfigs: {},
    sources: [],
    password: {},
    poster: {
      posterUrl: ''
    }
  };
};

export default getBlockedVideoData;